import { Check, Star } from "@phosphor-icons/react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import FilterButton from "common/components/ui/FilterButton";

import { FAVORITE_FILTER_OPTIONS } from "../../../../../../../constants";

interface FavoriteFilterProps {
  isFavorite: boolean;
  setFilter: (filter: boolean) => void;
}

export default function FavoriteFilter({
  isFavorite,
  setFilter,
}: FavoriteFilterProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <FilterButton size="sm" leftIcon={<Star weight="fill" />}>
          Favorite
        </FilterButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuList>
          {FAVORITE_FILTER_OPTIONS.map(({ text, value }) => (
            <DropdownMenuItem key={text} onClick={() => setFilter(value)}>
              {text}

              {isFavorite === value && <Check className="ml-auto" size={20} />}
            </DropdownMenuItem>
          ))}
        </DropdownMenuList>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
